import React from 'react';
import CreateModifierState from './createModifierState/CreateModifierState';
import ModalWindows from './components/ModalWindows/ModalWindows';
import ControlPanel from './components/ControlPanel/ControlPanel';
import Forms from './components/Forms/Forms';

const CreateModifierPage: React.FC = () => {
	return (
		<CreateModifierState>
			<ControlPanel />
			<Forms />
			<ModalWindows />
		</CreateModifierState>
	);
};

export default CreateModifierPage;
